import { render, staticRenderFns } from "./CustomCarousel.vue?vue&type=template&id=428bb4e1&"
import script from "./CustomCarousel.vue?vue&type=script&lang=ts&"
export * from "./CustomCarousel.vue?vue&type=script&lang=ts&"
import style0 from "./CustomCarousel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports